import script from "./CoacheSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./CoacheSetup.vue?vue&type=script&setup=true&lang=js"

import "./CoacheSetup.vue?vue&type=style&index=0&id=1ecf6371&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecf6371"]])

export default __exports__